export default __webpack_public_path__ + "static/media/status_icon_rejected.9469465f.svg";